'use strict';


var cookies = require('../cookies')();
var Transport = require('../transport');
var strFunc = require('../string');
var object = require('../object');
var fpr = require('fingerprintjs2');
var prefixedCookies = require('../cookies')('_hcfnl_');

var listOfCookie = [
  // ostrovok user id
  'userid',
  // ostrovok client user id
  prefixedCookies.fullName('funnel_uid'),
  // dynamic yield visitor id
  '_dyid',
  // domain visitor id (set on balancer)
  'uid',
  // Google analytics visitor id
  '_ga',
  // yandex metrica visitor id
  '_ym_uid',
  // exponea id
  '__exponea_etc__',
  // fingerprint
  prefixedCookies.fullName('fpr')
]

var req = {
  domain: document.location.hostname
  // cookie name: value, ..
};

function identify (call_sync) {
  var cookie_name = 'fpr';

  if (!prefixedCookies.get(cookie_name)) {
    var fpr_opt = {
      excludes: {
        timezoneOffset: true
      },
      audio: {
        timeout: 3000
      }
    };

    try {
      fpr.get(fpr_opt, function(components) {
        var values = components.map(function (component) {
          return component.value;
        });
        var murmur = fpr.x64hash128(values.join(''), 31);
        prefixedCookies.set(cookie_name, murmur);

        sync();
      });
    } catch (e) {
      window.hcfunnel('event', 'tracking', 'funnel', 'fpr_error', {
        name: e.name,
        stack: e.stack,
        message: e.message
      });

      sync();
    }
  }
}

// create and sign cookie list
function getCookieList (listOfCookie) {
  var str = '',
      list = {};

  listOfCookie = listOfCookie.sort();

  for(var i = 0; i < listOfCookie.length; i++) {
    var name = listOfCookie[i],
        value = cookies.get(name) || '';

    list[name] = value;
    str += '|' + name + '=' + value;
  }

  var hash = strFunc.hashCode(str);

  return [hash, list];
}

// send if it changed
function sync () {
  var cookieList = getCookieList(listOfCookie),
      cookieName = 'csync_h';

  var oldSign = prefixedCookies.get(cookieName);
  var newSign = cookieList[0];

  if (oldSign != newSign) {
    (new Transport('/csync')).send(object.assign(req, cookieList[1]));
    prefixedCookies.set(cookieName, newSign, 86400 * 30 * 1000);
  }
}

module.exports = {
  once: sync,
  periodically: function() {
    setInterval(sync, 10 * 60 * 1000);
  },
  identify: identify
};



//////////////////
// WEBPACK FOOTER
// ./lib/funnel/synccookies.js
// module id = 29
// module chunks = 1 3